import { createContext, use } from 'react'
import { InputModalProps } from '../providers'

type ModalContextValue = {
  showInputModal?: <T>(props: InputModalProps<T>) => Promise<T | undefined>
}

export const ModalContext = createContext<ModalContextValue>({
  showInputModal: undefined,
})

export function useModalContext() {
  return use(ModalContext)
}
